module.exports = __webpack_public_path__ + "img/globe.69a11882.svg";